import styled from 'styled-components';

export const Wrapper = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100vw;
	height: calc(var(--vh, 1vh) * 100 - 60px);
	overflow-y: auto;
	text-align: center;
	padding: 10px 10px 0 10px;
	gap: 10px;

	@media (min-width: 600px) {
		flex-grow: 1;
		height: calc(var(--vh, 1vh) * 100 - 160px);
		width: 100%;
		padding: 30px 30px 10px;
		margin: 0;
	}
`;

export const Title = styled.h2`
	position: sticky;
	top: 0;
	color: #05275d;
	width: 100%;
	text-align: center;
	font-family: Work Sans;
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: -0.56px;
	margin: 0px;
	text-align: center;
	z-index: 1;
`;

export const SubTitle = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 110%; /* 17.6px */
	max-width: 450px;
`;

export const BoxWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	overflow: auto;
	gap: 16px;
	padding-bottom: 20px;
`;

export const StartPopUpTitle = styled.h4`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 28px */
`;

export const StartPopUpSubtitle = styled.h4`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%; /* 19.6px */
	word-wrap: break-word;
	white-space: pre-line;
`;

export const PopUpStartWrapper = styled.div`
	max-width: 350px;
	text-align: center;
`;

export const ConfirmationButton = styled.button`
	display: flex;
	width: 180px;
	padding: 14px 63px 14px 62px;
	justify-content: center;
	align-items: center;
	border-radius: 100px;
	background: var(--Purple, linear-gradient(10deg, #48068a 10%, #4322c6 65%));

	color: #fff;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.64px;
	text-transform: uppercase;
	margin: 40px auto 10px auto;
`;

export const IntroductionWrapper = styled.div`
	width: 100%;
	height: 100%;
	z-index: 3;
	top: 0;
	position: absolute;
	overflow: hidden;

	@media (min-width: 768px) {
		position: absolute;
		top: auto;
	}
`;

export const RelativeAnchor = styled.div`
	width: auto;
	height: auto;
	position: static;
`;
